<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style>
#app {
  font-family: Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #042653;
  width: 100%;
}
h1, h2, h3 {
  font-weight: normal;
}
.float.right {
  float: right;
}
</style>



// WEBPACK FOOTER //
// App.vue?0b7b68a8